import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import {
  useLazyAdminStatusQuery,
  useLazyPropertyCreateQuery,
  useLazyPropertyListQuery,
  useLazyPropertyStatusQuery,
} from "../../redux/api/api";
import { editIcon, viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";

const PropertyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [btn, setBtn] = useState(false);
  const [createList, setCreateList] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // RTK QUERY
  const [propertyListApi] = useLazyPropertyListQuery();
  const [propertyCreateApi] = useLazyPropertyCreateQuery();
  const [propertyStatusApi] = useLazyPropertyStatusQuery();

  const getPropertyList = (search_value, row_value) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setSearch(search_value);
    setRow(row_value);
    dispatch(saveLoader(true));
    propertyListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.properties);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPropertyList(search, row);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    propertyStatusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getPropertyList(search, row);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  const getPropertyCreate = () => {
    propertyCreateApi()
      .unwrap()
      .then((res) => {
        setCreateList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPropertyCreate();
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"property-list"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
          </Row>
          <div className="d-flex ac-jb">
            <div className="col-md-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) => getPropertyList(search, e.target.value)}
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="col-md-3 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) => getPropertyList(search, e.target.value)}
                value={row}
              >
                <option value={""}>Select Category</option>
                {createList?.categories?.map((item, ind) => {
                  return <option value={item?.id}>{item?.name}</option>;
                })}
              </select>
            </div>
            <div className="col-md-2  p-0">
              <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  getPropertyList(search, row, date, toDate);
                }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-2 p-0">
              <DatePicker
                selected={toDate}
                onChange={(date) =>
                  getPropertyList(search, row, fromDate, date)
                }
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
          </div>
          <div className="col-md-3 p-0 mt-3">
            <input
              className="form-control bg-white"
              placeholder="Eg: Name, State, City, Location"
              style={{ width: "300px" }}
              onChange={(e) => getPropertyList(e.target.value, row)}
              value={search}
            />
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>Category</th>
                  <th>Owner Id</th>
                  <th>Property ID</th>
                  <th>Property Name</th>
                  <th>Image</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>{item?.category?.name}</td>
                      <td>{item?.owner?.owner_id}</td>
                      <td>{item?.property_id}</td>
                      <td>{item?.name}</td>
                      <td>
                        <img
                          src={item?.image}
                          style={{ width: "100px", height: "80px" }}
                          alt="property-img"
                          class="img-fluid"
                        />
                      </td>
                      <td>{item?.state?.name}</td>
                      <td>{item?.city?.name}</td>
                      <td>{item?.location?.name}</td>
                      <td>
                        <button
                          className={`${
                            item?.status == 1 ? "btn-success" : "btn-danger"
                          } px-2 py-1 rounded-1 border-0 text-white`}
                          onClick={() => statusChange(item?.id)}
                          disabled={btn}
                        >
                          {item?.status == 1 ? "Active" : "Deactive"}
                        </button>
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            className="cust-btn"
                            onClick={() =>
                              navigate("/property-view", {
                                state: { type: "view", data: item },
                              })
                            }
                          >
                            <img src={viewIcon} className="edit-btn" />
                          </button>
                          <button
                            className="cust-btn"
                            onClick={() =>
                              navigate("/property", {
                                state: { type: "edit", data: item },
                              })
                            }
                          >
                            <img src={editIcon} className="edit-btn" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyList;
